<template>
  <div class="pw-text-overflow">
    <div class="text" ref="text">
      <slot />
    </div>

    <span class="tooltip-text" v-if="isOverflowing" :class="classes">
      {{ tooltipText }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TextOverflow',
  props: {
    position: {
      type: String,
      default: 'top',
    },
  },
  data() {
    return {
      tooltipText: '',
      fullWidth: 0,
      scrollWidth: 0,
    };
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize);
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.tooltipText = this.$slots.default[0].text;

    requestAnimationFrame(() => {
      this.handleResize();
    });
  },
  computed: {
    isOverflowing() {
      return this.scrollWidth > this.fullWidth;
    },
    classes() {
      return [`tooltip-text--${this.position}`];
    },
  },
  updated() {
    if (this.$slots.default[0].text !== this.tooltipText) {
      this.tooltipText = this.$slots.default[0].text;
      this.handleResize();
    }
  },
  methods: {
    handleResize() {
      this.fullWidth = this.$refs.text.clientWidth;
      this.scrollWidth = this.$refs.text.scrollWidth;
    },
  },
};
</script>

<style lang="scss">
.pw-text-overflow {
  position: relative;

  .text {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Tooltip text */
  .tooltip-text {
    visibility: hidden;
    width: auto;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 15px;
    border-radius: 6px;
    position: absolute;
    z-index: 5;

    /* Fade in tooltip */
    opacity: 0;
    transition: opacity 0.3s;
  }

  /* Tooltip arrow */
  .tooltip-text {
    &::after {
      content: '';
      position: absolute;
      border-style: solid;
      border-width: 6px;
    }

    &--top::after {
      top: 100%;
      left: 50%;
      border-color: #555 transparent transparent transparent;
    }

    &--bottom::after {
      bottom: 100%;
      left: 50%;
      border-color: transparent transparent #555 transparent;
    }

    &--right::after {
      bottom: 32%;
      right: 100%;
      border-color: transparent #555 transparent transparent;
    }

    &--left::after {
      bottom: 32%;
      left: 100%;
      border-color: transparent transparent transparent #555;
    }
  }
}

.pw-text-overflow .tooltip-text {
  &--top {
    bottom: 125%;
  }
  &--bottom {
    top: 125%;
  }

  &--right {
    width: 100%;
    bottom: -50%;
    left: 102%;
  }

  &--left {
    width: 100%;
    bottom: -50%;
    right: 102%;
  }
}

.pw-text-overflow:hover {
  .tooltip-text {
    visibility: visible;
    opacity: 1;
  }
}
</style>
